import { render, staticRenderFns } from "./inspectionPatients.vue?vue&type=template&id=df61cccc&scoped=true"
import script from "./inspectionPatients.vue?vue&type=script&lang=js"
export * from "./inspectionPatients.vue?vue&type=script&lang=js"
import style0 from "./inspectionPatients.vue?vue&type=style&index=0&id=df61cccc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df61cccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df61cccc')) {
      api.createRecord('df61cccc', component.options)
    } else {
      api.reload('df61cccc', component.options)
    }
    module.hot.accept("./inspectionPatients.vue?vue&type=template&id=df61cccc&scoped=true", function () {
      api.rerender('df61cccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/treatment/patients/inspectionPatients.vue"
export default component.exports